import React, { JSX } from "react";
import { app_singleton } from "../../utility/app_singleton";
import ContentPopup from "../popup-with-bar/content-popup";
import { CircularProgress } from "@mui/material";
import Popup, { ButtonProps } from "../popup/popup";
import CallbackComponent from "./callback_component";
import { MessageComponent } from "./message_component";
import Observer_loading_popup = app_singleton.Observer_loading_popup;

interface Props { }

type State = StateOpen | { open: false }

interface StateOpen {
    open: true,
    loading: boolean,
    data: app_singleton.loading_popup_data,
    handler: loading.ILoadingStrategy
}


export namespace loading {

    export type Post = ICallback | IMessage

    export interface ICallback {
        success_ca: () => void,
        error_ca: (err: Error) => void,
        min_duration?: number
    }

    export interface IMessage {
        success: (data: any, close: () => void) => ILoadingPopupMessageState,
        error: (err: Error, close: () => void) => ILoadingPopupMessageState,
        min_duration?: number
    }


    export interface ILoadingPopupMessageState {
        text: string,
        button: ButtonProps,
    }

    export interface ILoadingStrategy {
        obj: app_singleton.loading_popup_data;

        handle_close(): void
        render(): JSX.Element
    }

    export class LoadingComponent implements ILoadingStrategy {

        obj: app_singleton.loading_popup_data

        constructor(obj: app_singleton.loading_popup_data, father: LoadingPopup) {
            this.obj = obj;
            this.init(father);
        }

        init(father: LoadingPopup) {
            const post = this.obj.post
            const duration = post?.min_duration ?? 0

            setTimeout(() => this.handle_resolve(father, this.obj), duration);
        }

        handle_close() {
            return;
        }

        handle_resolve = (father: LoadingPopup, obj: app_singleton.loading_popup_data) => {
            let handler: ILoadingStrategy = this;
            if (obj.post === undefined)
                this.obj.promise.finally(() => {
                    father.close()
                })
            else if ("success_ca" in obj.post)
                handler = new CallbackComponent(obj, obj.post, father, this);
            else
                handler = new MessageComponent(obj, this, father, obj.post);

            father.setState({
                open: true,
                handler: handler
            })
        }

        render() {
            return (
                <ContentPopup>
                    <CircularProgress />
                    {this.obj.text}
                </ContentPopup>
            )
        }
    }
}



export default class LoadingPopup extends React.Component<Props, State> implements Observer_loading_popup {

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false
        }

        this.close.bind(this);

    }

    componentDidMount() { app_singleton.event.loading_popup.attach(this) }
    componentWillUnmount() { app_singleton.event.loading_popup.detach(this); }

    update_loading_popup(obj: app_singleton.loading_popup_data) {

        const handler = new loading.LoadingComponent(obj, this);

        this.setState({
            open: true,
            loading: true,
            data: obj,
            handler: handler
        })
    }

    close = () => {
        this.setState({ open: false })
    }

    render() {
        const state = this.state;

        if (!state.open)
            return <></>

        return (
            <Popup open={state.open} title={state.data.title} handle_close={state.handler.handle_close}>
                {state.handler.render()}
            </Popup>

        )
    }
}
